import { CampaignCampaignStatus } from "@/api/__generated__/models";
import { PageContainer } from "@/components/common/page-container";
import { CampaignCard } from "@/components/shared/campaign-card";
import { CAMPAIGN_INFO } from "@/constants/campaign";
import { routes } from "@/constants/url";
import { useWorkspaceNavigate } from "@/lib/router/use-workspace-navigate";
import { WorkspaceLink } from "@/lib/router/workspace-link";
import { useCampaigns } from "@/routes/campaigns/hooks/use-campaigns";
import { calculateRemainingDays } from "@/utils/date";
import { getSnsLabel } from "@/utils/sns";
import { Button, Icon, Typography } from "@backpac/monica";

export function CampaignsPage() {
  return (
    <PageContainer
      nav={
        <PageContainer.Navigation
          title="Campaigns"
          links={[
            { to: routes.CAMPAIGNS.root, text: "Discover" },
            { to: routes.CAMPAIGNS.my, text: "My campaigns" },
          ]}
        />
      }
    >
      <Contents />
    </PageContainer>
  );
}

function Contents() {
  const { data: campaigns } = useCampaigns({ status: CampaignCampaignStatus.SIGN_UP });

  if (campaigns.length === 0) {
    return <Empty />;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
      {campaigns.map((campaign) => (
        <WorkspaceLink key={campaign.id} to={routes.CAMPAIGNS._view(campaign.id)}>
          <CampaignCard
            campaignTitle={campaign.title}
            materialTitle={`${campaign.artistName} - ${campaign.trackName}`}
            thumbnail={CAMPAIGN_INFO[campaign.id]?.material.cover}
            applyDates={calculateRemainingDays(CAMPAIGN_INFO[campaign.id]?.campaignUploadEndDate)}
            platform={getSnsLabel(CAMPAIGN_INFO[campaign.id]?.platform)}
          />
        </WorkspaceLink>
      ))}
    </div>
  );
}

function Empty() {
  const navigate = useWorkspaceNavigate();

  return (
    <div className="h-[calc(100vh-280px)] flex flex-col items-center justify-center">
      <Icon name="announce" bgColor="brandTangerine" iconSize="16px" />
      <Typography size="lg" weight={600} className="mt-3 mb-2">
        New campaigns coming soon
      </Typography>
      <Typography size="paragraphXs" color="textMuted" className="mb-4 text-center">
        We're preparing new opportunities for creators like you.
        <br />
        In the meantime, check out the music library and keep creating.
      </Typography>
      <Button onClick={() => navigate(routes.MUSIC.root)}>Explore music library</Button>
    </div>
  );
}
